import { STAFF_SPA_ROUTE_PATHS, type StaffSPARoutePath } from './staff-spa-route-paths';

const PATH_SET = new Set<string>(STAFF_SPA_ROUTE_PATHS as readonly string[]);

import { ROUTE_PATHS } from '../../app/router/route-paths';

/**
 * Явные отличия path в React Router от строки в `routes_allowed`.
 * Ключи — как в `StaffSPARoutePaths` / `routes_allowed` на бэкенде.
 */
const FRONTEND_PATH_TO_BACKEND: Record<string, StaffSPARoutePath> = {
  [ROUTE_PATHS.superadminOrganizations]: '/platform-organizations',
  [ROUTE_PATHS.superadminTenantRequests]: '/platform-tenant-requests',
  [ROUTE_PATHS.superadminPlans]: '/platform-plans',
  [ROUTE_PATHS.superadminQRCodeConfig]: '/platform-qrcode-config',
  /** Единый org surface; ключ capabilities — `/organization`. */
  [ROUTE_PATHS.organizationProfileEdit]: '/organization',
  /** Вкладки хаба `/users`: гейты по ключам staff-каталога и клиентов. */
  [ROUTE_PATHS.tenantUsersStaffTab]: '/users',
  [ROUTE_PATHS.tenantUsersClientsTab]: '/clients',
  [ROUTE_PATHS.tenantUsersTrainersTab]: '/staff',
  [ROUTE_PATHS.tenantUsersAccessRbacTab]: '/access-rbac',
};

/** Карточка организации на платформе: тот же capability-ключ, что у списка (`/platform-organizations`). */
const PLATFORM_ORG_DETAIL = /^\/superadmin\/organizations\/\d+$/;

/** Карточка заявки на подключение: тот же capability-ключ, что у списка (`/platform-tenant-requests`). */
const TENANT_REQUEST_DETAIL = /^\/superadmin\/tenant-requests\/\d+$/;

export function toBackendStaffSpaPath(frontendPath: string): StaffSPARoutePath | null {
  const path = frontendPath.replace(/\/+$/, '') || '/';
  if (path === ROUTE_PATHS.scheduleTrainings) {
    return '/schedule';
  }
  const mapped = FRONTEND_PATH_TO_BACKEND[path];
  if (mapped) return mapped;
  if (PLATFORM_ORG_DETAIL.test(path)) return '/platform-organizations';
  if (TENANT_REQUEST_DETAIL.test(path)) return '/platform-tenant-requests';
  if (PATH_SET.has(path)) return path as StaffSPARoutePath;
  return null;
}

/** Исторический ключ `routes_allowed` до ADR-0026; эквивалентен `/schedule`. */
export type StaffScheduleRouteLegacyKey = '/schedule-trainings';

export function toFrontendStaffPath(backendRouteKey: StaffSPARoutePath | StaffScheduleRouteLegacyKey): string {
  if (backendRouteKey === '/platform-organizations') {
    return ROUTE_PATHS.superadminOrganizations;
  }
  if (backendRouteKey === '/platform-tenant-requests') {
    return ROUTE_PATHS.superadminTenantRequests;
  }
  if (backendRouteKey === '/platform-plans') {
    return ROUTE_PATHS.superadminPlans;
  }
  if (backendRouteKey === '/platform-qrcode-config') {
    return ROUTE_PATHS.superadminQRCodeConfig;
  }
  if (backendRouteKey === '/schedule' || backendRouteKey === '/schedule-trainings') {
    return ROUTE_PATHS.schedule;
  }
  return backendRouteKey;
}
